import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AccordionModule, MultiSelectModule, SharedModule } from '../shared';
import { ContractCumulativeEffects } from './store/contract-cumulative.effects';
import * as reducer from './store/contract-cumulative.reducer';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        SharedModule,
        AccordionModule,
        MultiSelectModule,
        StoreModule.forFeature(
            reducer.contractCumulativesFeatureKey,
            reducer.reducer
        ),
        EffectsModule.forFeature([ContractCumulativeEffects])
    ]
})
export class ContractCumulativeModule {}
